/**
 * The tabs of the Storefront page (`/storefront`), in the strip's order: General (the branding),
 * Banners (scheduled slides), Theme and Terminology (the storefront's nouns). The tab rides the
 * URL (`?tab=`), so a tab is a link: the legacy theme, rarity and terminology bookmarks land on
 * theirs. Every member sees every tab; edits gate on editor inside it.
 */
export const STOREFRONT_TABS = ["general", "banners", "theme", "terminology"] as const;
export type StorefrontTab = (typeof STOREFRONT_TABS)[number];

export const STOREFRONT_TAB_LABELS: Record<StorefrontTab, string> = {
  general: "General",
  banners: "Banners",
  theme: "Theme",
  terminology: "Terminology",
};

export function isStorefrontTab(value: unknown): value is StorefrontTab {
  return typeof value === "string" && (STOREFRONT_TABS as readonly string[]).includes(value);
}

export interface StorefrontSearch {
  tab?: StorefrontTab;
}

/** The route's `validateSearch`: an unknown tab is dropped, and the page shows General. */
export function parseStorefrontSearch(search: Record<string, unknown>): StorefrontSearch {
  return { tab: isStorefrontTab(search.tab) ? search.tab : undefined };
}

/** The tab to show: the requested one, else General. */
export function resolveStorefrontTab(requested: StorefrontTab | undefined): StorefrontTab {
  return requested ?? "general";
}
